import { Routes } from '@angular/router';
import { productGuard } from 'app/core/guards/product.guard';

export const proRoutes: Routes = [
    {
        path: 'dashboard/daily-digest',
        title: 'Pulse - Daily Digest',
        canActivate: [productGuard('insight', 'pro')],
        loadComponent: () =>
            import('app/products/productivity/dashboards/daily-digest/daily-digest.component').then(
                m => m.DailyDigestComponent
            ),
    },
    {
        path: 'dashboard/productivity-home-page-v2',
        title: 'Home Page',
        canActivate: [productGuard('pro')],
        loadComponent: () =>
            import('app/products/productivity/dashboards/prod-home-page-v2/prod-home-page-v2.component').then(
                m => m.ProductivityHomePageV2Component
            ),
    },
    {
        path: 'dashboard/productivity-insights',
        title: 'Leadership Insights',
        canActivate: [productGuard('pro')],
        loadChildren: () =>
            import('app/products/productivity/dashboards/prod-insights/prod-insights.module').then(
                m => m.ProductivityInsightsModule
            ),
    },
    {
        path: 'dashboard/productivity-gop',
        title: 'Forecasted GOP',
        canActivate: [productGuard('pro')],
        loadComponent: () =>
            import('app/products/productivity/dashboards/prod-gop/prod-gop.component').then(
                m => m.ProductivityGopComponent
            ),
    },
    {
        path: 'dashboard/productivity-cockpit-v2',
        title: 'Cockpit',
        canActivate: [productGuard('pro')],
        loadComponent: () =>
            import('app/products/productivity/dashboards/prod-cockpit-v2/prod-cockpit-v2.component').then(
                m => m.ProductivityCockpitComponentV2
            ),
    },
    {
        path: 'dashboard/productivity-finance',
        title: 'Finance Control',
        canActivate: [productGuard('pro')],
        loadComponent: () =>
            import('app/products/productivity/dashboards/prod-finance/prod-finance.component').then(
                m => m.ProductivityFinanceComponent
            ),
    },
    {
        path: 'dashboard/productivity-global-mapping',
        title: 'Global Mapping',
        canActivate: [productGuard('pro')],
        loadComponent: () =>
            import('app/products/productivity/dashboards/productivity-global-mapping/productivity-global-mapping.component').then(
                m => m.ProductivityGlobalMappingDashboardComponent
            ),
    },
    {
        path: 'dashboard/productivity-settings',
        title: 'Settings',
        canActivate: [productGuard('pro')],
        loadComponent: () =>
            import('app/products/productivity/dashboards/prod-settings/prod-settings.component').then(
                m => m.ProductivityCockpitSettingsDashboardComponent
            ),
    },
    {
        path: 'dashboard/productivity-targets-v2',
        title: 'Targets',
        canActivate: [productGuard('pro')],
        loadChildren: () =>
            import('app/products/productivity/dashboards/prod-cockpit-targets/prod-cockpit-targets.module').then(
                m => m.ProductivityCockpitTargetsModule
            ),
    },
    {
        path: 'dashboard/productivity-benchmark-v2',
        title: 'Benchmark',
        canActivate: [productGuard('pro')],
        loadComponent: () =>
            import('app/products/productivity/dashboards/prod-benchmark-v2/prod-benchmark-v2.component').then(
                m => m.ProductivityBenchmarkComponentV2
            ),
    },
    {
        path: 'dashboard/prod-sop',
        title: 'SOP - User Guide',
        canActivate: [productGuard('pro')],
        loadComponent: (): any =>
            import('app/products/productivity/dashboards/prod-SOP/prod-SOP').then(
                m => m.ProdSOPComponent
            ),
    },
];
